export interface GetReportsResponse {
    activeReportSubscriptions: ActiveReportSubscriptionReportModel[];
    purchasableReports: PurchasableReportModel[];
    pendingMetaReports: PurchasedReportModel[];
    purchasedReports: PurchasedReportModel[];
}

export interface IsCompanyReportPurchasedResponse
{
    anyFulfilledOrders: boolean;
    anyPendingOrders: boolean;
}

export interface PurchasableReportModel {
    reportId: number;
    productCode: string;
    name: string;
    description: string;
    imageUrl: string;
    isComingSoon: boolean;
    url: string;
    isInAppPurchaseEnabled: boolean;
}

export interface ActiveReportSubscriptionReportModel {
    reportId: number;
    reportTypeId: number;
    reportName: string;
    description: string;
    imageUrl: string;
    isComingSoon: boolean;
    reportIdentifier: string;
    workspaceIdentifier: string;
}

export interface PurchasedReportModel extends PurchasableReportModel {
    purchaseDate: string;
    purchasedBy: string;
    purchasedByEmail: string;
    orderGuid: string;
    expiryDate: string;
    showInPlatform: boolean;
}

export interface GetAllReportsResponse {
    reports: ReportModel[];
}

export interface GetCustomerReportsResponse {
    customerReports: CustomerReportModel[];
    reportTypes: ReportTypeModel[];
}

export interface CustomerReportModel {
    customerReportId: number;
    reportId: number;
    customerId: number;
    reportTypeId: number;
    showForAffiliatedCompanies?: boolean;
    showForAffiliatedVessels?: boolean;
}

export interface ReportTypeModel {
    reportTypeId: number;
    name: string;
}

export interface ReportModel {
    reportId: number;
    reportTypeId: number;
    reportName: string;
    reportDescription: string;
    reportImage: string;
    isComingSoon: boolean;
    reportIdentifier: string;
    workspaceIdentifier: string;
}

export interface SaveCustomerReportsRequest {
    customerReportsToDelete: CustomerReportModel[];
    customerReportsToUpdate: CustomerReportModel[];
    customerReportsToAdd: CustomerReportModel[];
}

export interface SaveCustomerReportsResponse {

}

export enum ReportTypeIdEnum {
    Vessel = 2,
    Company = 3,
}